import { useLang, type Lang } from '@/stores/lang';

const ORDER: Lang[] = ['es', 'gb', 'de', 'fr', 'nl', 'it'];

const NAMES: Record<Lang, string> = {
  es: 'Español',
  gb: 'English',
  de: 'Deutsch',
  fr: 'Français',
  nl: 'Nederlands',
  it: 'Italiano',
};

// Circular country flags (circle-flags, MIT licensed) self-hosted as SVG so
// they render identically on every OS — Windows can't draw flag emoji as
// glyphs. Files live in /public/flags/<code>.svg.
const flagSrc = (code: Lang) => `/flags/${code}.svg`;

export function LanguageBar() {
  const { lang, setLang } = useLang();
  return (
    <div className="rounded-full bg-ink-soft/80 border border-line px-2 py-1.5 flex items-center gap-2">
      {ORDER.map((code) => {
        const selected = code === lang;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            aria-label={NAMES[code]}
            aria-pressed={selected}
            title={NAMES[code]}
            className="block"
          >
            <img
              src={flagSrc(code)}
              alt={NAMES[code]}
              loading="lazy"
              className={[
                'w-6 h-6 block rounded-full transition-opacity',
                selected
                  ? 'opacity-100 ring-2 ring-gold'
                  : 'opacity-55 hover:opacity-90',
              ].join(' ')}
            />
          </button>
        );
      })}
    </div>
  );
}
